module.exports = __webpack_public_path__ + "static/media/equilibre.d5438cdb.svg";